module.exports = __webpack_public_path__ + "static/media/nfse-premium-icon.cafa7461.png";